// src/features/leavetracker/MyData/api.js

import { handleResponse } from '../../../utils/apiHandler';

const API_URL = process.env.REACT_APP_API_ENDPOINT;
const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('access_token')}`
});

/**
 * Fetches leave summary for a given year (default: current year)
 * @param {number} year
 * @returns {Promise<object[]>}
 */
export async function fetchLeaveSummary(year = new Date().getFullYear()) {
  const url = `${API_URL}/api/employee/leaves/summary/?year=${year}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(res, 'Failed to fetch leave summary');
}

/**
 * Posts a new leave request
 * @param {object} payload
 * @returns {Promise<object>}
 */
/**
 * Fetch all leave requests for the logged-in employee
 */
export async function getLeaveRequests() {
  const res = await fetch(`${API_URL}/api/employee/leaves/`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(res, 'Failed to fetch leave requests');
}

/**
 * Cancel a leave request by ID
 * @param {number} id
 */
export async function cancelLeaveRequest(id) {
  const res = await fetch(`${API_URL}/api/employee/leaves/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ status_of_leave: 'Cancelled' }),
  });
  return handleResponse(res, 'Failed to cancel leave request');
}

export async function postLeaveRequest(payload) {
  const res = await fetch(`${API_URL}/api/employee/leaves/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify(payload),
  });
  return handleResponse(res, 'Failed to apply leave');
}
